import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enUS from './locales/en-US.json';
import enCA from './locales/en-CA.json';
import frCA from './locales/fr-CA.json';
import frFR from './locales/fr-FR.json';
import deDE from './locales/de-DE.json';
import itIT from './locales/it-IT.json';
import enGB from './locales/en-GB.json';
import enAU from './locales/en-AU.json';
import esES from './locales/es-ES.json';

const resources = {
  'en-US': { translation: enUS },
  'en-CA': { translation: enCA },
  'fr-CA': { translation: frCA },
  'fr-FR': { translation: frFR },
  'de-DE': { translation: deDE },
  'it-IT': { translation: itIT },
  'en-GB': { translation: enGB },
  'en-AU': { translation: enAU },
  'es-ES': { translation: esES },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en-US', // Set default language explicitly
    fallbackLng: 'en-US',
    supportedLngs: ['en-US', 'en-CA', 'fr-CA', 'fr-FR', 'de-DE', 'it-IT', 'en-GB', 'en-AU', 'es-ES'],

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },

    // Debug mode to see what's happening
    debug: false,
  });

export default i18n;
